
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },

        {
  hid: 'description',
  name: 'description',
  content: 'Experience the thrill of water sports in Goa. From exciting jet skiing to relaxing scuba diving, enjoy a fun-filled day on the water with friends and family.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Dive into adventure with the best water sports package in Goa. Enjoy jet skiing, parasailing, and more at beautiful beaches.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Get ready for adventure with the Goa Water Sports Package. Enjoy thrilling activities like jet skiing and scuba diving at stunning beaches.',
},



        {
          hid: 'keywords',
          name: 'keywords',
          content: 'water rides in goa, water rides in goa price, water rides in goa beach, water rides in goa in june, water rides in goa in september, water rides in goa in august, best beach for water rides in goa, water rides in goa beaches, best water rides in goa, goa water rides season',
        },
       
      ],
    };
  },

  components: {},
  data() {
    return {

      reasons: [
  {
    title: "Thrilling Activities",
    text: "Experience heart-pounding adventures with exciting water sports like jet skiing, parasailing, and scuba diving!",
  },
  {
    title: "Fun for All Ages",
    text: "Whether you're a seasoned adventurer or a first-timer, there's a water sport for everyone to enjoy!",
  },
  {
    title: "Safety First",
    text: "All activities are conducted with safety in mind, with trained instructors ensuring a secure experience.",
  },
  {
    title: "Convenient Booking",
    text: "Easily book your water sports package through the Goa App for hassle-free planning and great deals!",
  },
],


    
      title: 'Water Rides in Goa - Water Rides in Goa Price',
    };
  },

  jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-03T11%3A09%3A52.609Zbumper-ride-grande-island.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=Pm01zT0K9WdROv0ENZNSoIhRkXleFOOAyTlznXU1eA7eiGuBGyX3JKUO6FdgnASKtudwxnDJmLBM1IpJ1dFFRIGRBWZVQvy8jyOid3hEz2Vxe9L5AbQpOtRfK1n3D5b7QNLd6mxd05o4VfApjVFKF2QnXaYeN%2Bd84ZRzVvIuGoi2CLkhrokUzybMBWN1sbBJZfUbXH7q3q1bqcfx%2BrBVMVJjMbGS79yOJyQLCjWfqicEAaDqL%2BmeQS0ItEQYVoY7hB6S50%2B7qufTD3%2Fwt9O2l2FqWcNU3PaWpZZoEpc6ZGBuJP7pssSCx27rfg5CkfWRTADgII0VDIZBn%2BLmL%2FdirQ%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-03T11%3A09%3A52.609Zbumper-ride-grande-island.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=Pm01zT0K9WdROv0ENZNSoIhRkXleFOOAyTlznXU1eA7eiGuBGyX3JKUO6FdgnASKtudwxnDJmLBM1IpJ1dFFRIGRBWZVQvy8jyOid3hEz2Vxe9L5AbQpOtRfK1n3D5b7QNLd6mxd05o4VfApjVFKF2QnXaYeN%2Bd84ZRzVvIuGoi2CLkhrokUzybMBWN1sbBJZfUbXH7q3q1bqcfx%2BrBVMVJjMbGS79yOJyQLCjWfqicEAaDqL%2BmeQS0ItEQYVoY7hB6S50%2B7qufTD3%2Fwt9O2l2FqWcNU3PaWpZZoEpc6ZGBuJP7pssSCx27rfg5CkfWRTADgII0VDIZBn%2BLmL%2FdirQ%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-03T11%3A09%3A52.609Zbumper-ride-grande-island.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=Pm01zT0K9WdROv0ENZNSoIhRkXleFOOAyTlznXU1eA7eiGuBGyX3JKUO6FdgnASKtudwxnDJmLBM1IpJ1dFFRIGRBWZVQvy8jyOid3hEz2Vxe9L5AbQpOtRfK1n3D5b7QNLd6mxd05o4VfApjVFKF2QnXaYeN%2Bd84ZRzVvIuGoi2CLkhrokUzybMBWN1sbBJZfUbXH7q3q1bqcfx%2BrBVMVJjMbGS79yOJyQLCjWfqicEAaDqL%2BmeQS0ItEQYVoY7hB6S50%2B7qufTD3%2Fwt9O2l2FqWcNU3PaWpZZoEpc6ZGBuJP7pssSCx27rfg5CkfWRTADgII0VDIZBn%2BLmL%2FdirQ%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/watersports/water-rides-in-goa`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/watersports/water-rides-in-goa`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-03T11%3A09%3A52.609Zbumper-ride-grande-island.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=Pm01zT0K9WdROv0ENZNSoIhRkXleFOOAyTlznXU1eA7eiGuBGyX3JKUO6FdgnASKtudwxnDJmLBM1IpJ1dFFRIGRBWZVQvy8jyOid3hEz2Vxe9L5AbQpOtRfK1n3D5b7QNLd6mxd05o4VfApjVFKF2QnXaYeN%2Bd84ZRzVvIuGoi2CLkhrokUzybMBWN1sbBJZfUbXH7q3q1bqcfx%2BrBVMVJjMbGS79yOJyQLCjWfqicEAaDqL%2BmeQS0ItEQYVoY7hB6S50%2B7qufTD3%2Fwt9O2l2FqWcNU3PaWpZZoEpc6ZGBuJP7pssSCx27rfg5CkfWRTADgII0VDIZBn%2BLmL%2FdirQ%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-03T11%3A09%3A52.609Zbumper-ride-grande-island.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=Pm01zT0K9WdROv0ENZNSoIhRkXleFOOAyTlznXU1eA7eiGuBGyX3JKUO6FdgnASKtudwxnDJmLBM1IpJ1dFFRIGRBWZVQvy8jyOid3hEz2Vxe9L5AbQpOtRfK1n3D5b7QNLd6mxd05o4VfApjVFKF2QnXaYeN%2Bd84ZRzVvIuGoi2CLkhrokUzybMBWN1sbBJZfUbXH7q3q1bqcfx%2BrBVMVJjMbGS79yOJyQLCjWfqicEAaDqL%2BmeQS0ItEQYVoY7hB6S50%2B7qufTD3%2Fwt9O2l2FqWcNU3PaWpZZoEpc6ZGBuJP7pssSCx27rfg5CkfWRTADgII0VDIZBn%2BLmL%2FdirQ%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/watersports/water-rides-in-goa`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Water Rides in Goa",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            
            {
  "@type": "Product",
  "name": "Water Rides in Goa - Book @ ₹1499 Flat 40% Off",
  "description": "Enjoy the ultimate Water Rides in Goa with jet skiing, parasailing, banana boat, bumper, and speed boat rides for an action-packed experience!",
  "image": "https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-03T11%3A09%3A52.609Zbumper-ride-grande-island.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=Pm01zT0K9WdROv0ENZNSoIhRkXleFOOAyTlznXU1eA7eiGuBGyX3JKUO6FdgnASKtudwxnDJmLBM1IpJ1dFFRIGRBWZVQvy8jyOid3hEz2Vxe9L5AbQpOtRfK1n3D5b7QNLd6mxd05o4VfApjVFKF2QnXaYeN%2Bd84ZRzVvIuGoi2CLkhrokUzybMBWN1sbBJZfUbXH7q3q1bqcfx%2BrBVMVJjMbGS79yOJyQLCjWfqicEAaDqL%2BmeQS0ItEQYVoY7hB6S50%2B7qufTD3%2Fwt9O2l2FqWcNU3PaWpZZoEpc6ZGBuJP7pssSCx27rfg5CkfWRTADgII0VDIZBn%2BLmL%2FdirQ%3D%3D",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Goa App"
    }
  },
  "brand": {
    "@type": "Brand",
    "name": "Goa App"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "ratingCount": "89",
    "ratingValue": "5",
    "reviewCount": "44"
  },
  "offers": {
    "@type": "Offer",
    "price": "1499",
    "priceValidUntil": "2025-12-31",
    "priceCurrency": "INR",
    "availability": "InStock",
    "seller": {
      "@type": "Organization",
      "name": "Goa App"
    }
  }
},

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/watersports/water-rides-in-goa",
        "url": "https://www.goa.app/watersports/water-rides-in-goa",
        "name": "Water Rides in Goa",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-03T11%3A09%3A52.609Zbumper-ride-grande-island.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=Pm01zT0K9WdROv0ENZNSoIhRkXleFOOAyTlznXU1eA7eiGuBGyX3JKUO6FdgnASKtudwxnDJmLBM1IpJ1dFFRIGRBWZVQvy8jyOid3hEz2Vxe9L5AbQpOtRfK1n3D5b7QNLd6mxd05o4VfApjVFKF2QnXaYeN%2Bd84ZRzVvIuGoi2CLkhrokUzybMBWN1sbBJZfUbXH7q3q1bqcfx%2BrBVMVJjMbGS79yOJyQLCjWfqicEAaDqL%2BmeQS0ItEQYVoY7hB6S50%2B7qufTD3%2Fwt9O2l2FqWcNU3PaWpZZoEpc6ZGBuJP7pssSCx27rfg5CkfWRTADgII0VDIZBn%2BLmL%2FdirQ%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-03T11%3A09%3A52.609Zbumper-ride-grande-island.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=Pm01zT0K9WdROv0ENZNSoIhRkXleFOOAyTlznXU1eA7eiGuBGyX3JKUO6FdgnASKtudwxnDJmLBM1IpJ1dFFRIGRBWZVQvy8jyOid3hEz2Vxe9L5AbQpOtRfK1n3D5b7QNLd6mxd05o4VfApjVFKF2QnXaYeN%2Bd84ZRzVvIuGoi2CLkhrokUzybMBWN1sbBJZfUbXH7q3q1bqcfx%2BrBVMVJjMbGS79yOJyQLCjWfqicEAaDqL%2BmeQS0ItEQYVoY7hB6S50%2B7qufTD3%2Fwt9O2l2FqWcNU3PaWpZZoEpc6ZGBuJP7pssSCx27rfg5CkfWRTADgII0VDIZBn%2BLmL%2FdirQ%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-03T11%3A09%3A52.609Zbumper-ride-grande-island.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=Pm01zT0K9WdROv0ENZNSoIhRkXleFOOAyTlznXU1eA7eiGuBGyX3JKUO6FdgnASKtudwxnDJmLBM1IpJ1dFFRIGRBWZVQvy8jyOid3hEz2Vxe9L5AbQpOtRfK1n3D5b7QNLd6mxd05o4VfApjVFKF25QnXaYeN%2Bd84ZRzVvIuGoi2CLkhrokUzybMBWN1sbBJZfUbXH7q3q1bqcfx%2BrBVMVJjMbGS79yOJyQLCjWfqicEAaDqL%2BmeQS0ItEQYVoY7hB6S50%2B7qufTD3%2Fwt9O2l2FqWcNU3PaWpZZoEpc6ZGBuJP7pssSCx27rfg5CkfWRTADgII0VDIZBn%2BLmL%2FdirQ%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "The Water Rides in Goa offers an exciting mix of jet skiing, parasailing, banana boat rides, bumper rides, and speed boat experiences. Perfect for adventure lovers, this package promises thrills and unforgettable memories on Goa’s beautiful waters.",
        "breadcrumb": {
            "@id": "https://www.goa.app/watersports/water-rides-goa/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/watersports/water-rides-goa"]
        }]
      },
      {
        "@type": "FAQPage",
  "mainEntity": [
  {
      "@type": "Question",
      "name": "What water rides are available in Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "In Goa, you can enjoy a variety of water rides such as jet skiing, parasailing, banana boat rides, bumper rides, and speed boat rides."
      }
    },
    {
      "@type": "Question",
      "name": "What is the cost of water rides in Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Prices for water rides in Goa start at ₹400 for jet skiing and ₹899 for parasailing, with packages going up to ₹3,499 for premium experiences."
      }
    },
    {
      "@type": "Question",
      "name": "Are there any age restrictions for water rides?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Most water rides in Goa have age restrictions, particularly for activities like jet skiing and parasailing. It’s advisable to check with the operator for specific guidelines."
      }
    },
    {
      "@type": "Question",
      "name": "Do I need prior experience for water rides in Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "No prior experience is needed for most water rides in Goa, as professional instructors are present to guide you through each activity."
      }
    },
    {
      "@type": "Question",
      "name": "What is the best time for water rides in Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The best time for water rides in Goa is between November and April when the weather is perfect for outdoor activities."
      }
    },
    {
      "@type": "Question",
      "name": "Are safety measures provided during water rides?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, all water ride operators in Goa prioritize safety, providing essential safety gear such as life jackets and helmets."
      }
    },
    {
      "@type": "Question",
      "name": "Can I book water rides in Goa online?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely! You can easily book water rides online through various platforms, including the Goa App, which often offers special deals."
      }
    },
    {
      "@type": "Question",
      "name": "What should I wear for water rides in Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "It's recommended to wear a swimsuit or comfortable clothing and bring sunscreen and flip-flops for water rides in Goa."
      }
    },
    {
      "@type": "Question",
      "name": "Are meals included in water ride packages?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Some water ride packages may include meals or refreshments, but it's best to confirm these details at the time of booking."
      }
    },
    {
      "@type": "Question",
      "name": "How do I find the best water rides in Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "To find the best water rides in Goa, read online reviews, compare different packages, and look for promotions on platforms like the Goa App."
      }
    }  
        ]
      }
    ]
  };
},


};



  